import React, { lazy, useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import { Col, Row } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { SpinnerDotted } from 'spinners-react';
import envValues from '../../enviornment';
import { getCookies } from '../../hooks/useCookies';

const WeightLiftedChart = lazy(() => import('../Chart/WeightLiftedChart'));

function weightLiftedComponent() {
  const { userId } = useParams();
  const token = `Bearer ${getCookies('Token')}`;

  const [filter, setFilter] = useState('weekly');
  const [bodyData, setBodyData] = useState([]);
  const [excersizeData, setExcersizeData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [body, setBody] = useState('Neck');
  const [excersize, setExcersize] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [weightUnit, setWeightUnit] = useState('');

  const getBodyDataDropdown = async () => {
    try {
      const response = await axios.get(`${envValues.REACT_APP_API_ENDPOINT}/body-admin`);
      setBodyData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getExersizeDataDropdown = async () => {
    try {
      const response = await axios.post(
        `${envValues.REACT_APP_API_ENDPOINT}/body-admin/excersize`,
        {
          bodyPart: body,
        }
      );

      setExcersizeData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getWeightLiftedData = async (selectedFilter) => {
    console.log(selectedFilter, 'selectedFilter in weight');
    console.log(excersize, 'excersize in weight');
    console.log(body, 'body in weight');

    try {
      setIsLoading(true);

      const response = await axios.get(
        `${envValues.REACT_APP_API_ENDPOINT}/statistics/weight-lifted/${userId}?filter=${selectedFilter}&exercise=${excersize}&bodyName=${body}`,
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response.data.data.weightUnit, 'response.data.data.weightUnit');
      setWeightUnit(response.data.data.weightUnit);

      setGraphData(response.data.data.weightLifted);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWeightLiftedData(filter);
  }, [filter, excersize, body]);

  useEffect(() => {
    getBodyDataDropdown();
    getExersizeDataDropdown();
  }, []);
  useEffect(() => {
    getExersizeDataDropdown();
  }, [body]);
  useEffect(() => {
    if (excersizeData.length > 0) {
      setExcersize(excersizeData[0].exerciseName);
    }
  }, [excersizeData]);
  // console.log(weightUnit, 'unii');

  return (
    <div>
      <div className="inner_tab_head">
        <Tabs
          defaultActiveKey="weekly"
          id="justify-tab-example"
          className="mb-3"
          justify
          onSelect={(key) => key && setFilter(key)}
        >
          <Tab eventKey="weekly" title="Week">
            <div className="resp_table">
              <div className="row graph_section">
                <div className="col-md-6">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                    >
                      {bodyData.map((bodyItem) => (
                        <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                          {bodyItem.bodyName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                <div className="col-md-6 ">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={excersize}
                      onChange={(e) => setExcersize(e.target.value)}
                    >
                      {excersizeData?.map((bodyItem) => (
                        <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                          {bodyItem.exerciseName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  <Row className="mt-4">
                    <Col lg={6} className="mb-4">
                      <h3 className="graph_sectionh3">Weight Lifted</h3>
                    </Col>
                    <Col lg={6} className="mb-3">
                      <div className="dot_section d-flex gap-2 justify-content-end align-items-center">
                        <svg
                          width="28"
                          height="10"
                          viewBox="0 0 28 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_6444_27097)">
                            <rect
                              x="0.916016"
                              y="0.199219"
                              width="26.9512"
                              height="9.61066"
                              rx="4.80533"
                              fill="#228B22"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6444_27097">
                              <rect
                                x="0.916016"
                                y="0.199219"
                                width="26.9512"
                                height="9.61066"
                                rx="4.80533"
                                fill="white"
                              />
                            </clipPath>
                          </defs>
                        </svg>

                        <p className="graph_sectionp">Weight</p>
                      </div>
                    </Col>
                  </Row>
                  <WeightLiftedChart chartData={graphData} filter={filter} unit={weightUnit} />
                  <Row>
                    <Col lg={12} className="">
                      <div className="graph_sectionw dot_section d-flex gap-2 justify-content-end align-items-center">
                        <p>Note: 1 ton = {weightUnit === 'kg' ? ' 907.18474 kg' : '2,000 lbs'}</p>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </Tab>
          <Tab eventKey="monthly" title="Month">
            <div className="resp_table">
              <div className="row graph_section">
                <div className="col-md-6">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                    >
                      {bodyData.map((bodyItem) => (
                        <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                          {bodyItem.bodyName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={excersize}
                      onChange={(e) => setExcersize(e.target.value)}
                    >
                      {excersizeData?.map((bodyItem) => (
                        <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                          {bodyItem.exerciseName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <div className="graph_section mt-4">
                  <div className="col-md-12 mb-4">
                    <h3 className="graph_sectionh3">Weight Lifted</h3>
                  </div>
                  <WeightLiftedChart chartData={graphData} filter={filter} unit={weightUnit} />
                  <Row>
                    <Col lg={12} className="">
                      <div className="graph_sectionw dot_section d-flex gap-2 justify-content-end align-items-center">
                        <p>Note: 1 ton = {weightUnit === 'kg' ? ' 907.18474 kg' : '2,000 lbs'}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Tab>
          <Tab eventKey="yearly" title="Year">
            <div className="resp_table">
              <div className="row graph_section">
                <div className="col-md-6">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                    >
                      {bodyData.map((bodyItem) => (
                        <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                          {bodyItem.bodyName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={excersize}
                      onChange={(e) => setExcersize(e.target.value)}
                    >
                      {excersizeData?.map((bodyItem) => (
                        <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                          {bodyItem.exerciseName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <div className="graph_section mt-4">
                  <div className="col-md-12 mb-4">
                    <h3 className="graph_sectionh3">Weight Lifted</h3>
                  </div>
                  <WeightLiftedChart chartData={graphData} filter={filter} unit={weightUnit} />
                  <Row>
                    <Col lg={12} className="">
                      <div className="graph_sectionw dot_section d-flex gap-2 justify-content-end align-items-center">
                        <p>Note: 1 ton = {weightUnit === 'kg' ? ' 907.18474 kg' : '2,000 lbs'}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Tab>
          <Tab eventKey="all" title="Lifetime">
            <div className="resp_table">
              <div className="row graph_section">
                <div className="col-md-6">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={body}
                      onChange={(e) => setBody(e.target.value)}
                    >
                      {bodyData.map((bodyItem) => (
                        <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                          {bodyItem.bodyName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="table_select">
                    <Form.Select
                      aria-label="Select Body Part"
                      value={excersize}
                      onChange={(e) => setExcersize(e.target.value)}
                    >
                      {excersizeData?.map((bodyItem) => (
                        <option key={bodyItem.exerciseName} value={bodyItem.exerciseName}>
                          {bodyItem.exerciseName}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <div className="graph_section mt-4">
                  <div className="col-md-12 mb-4">
                    <h3 className="graph_sectionh3">Weight Lifted</h3>
                  </div>
                  <WeightLiftedChart chartData={graphData} filter={filter} unit={weightUnit} />
                  <Row>
                    <Col lg={12} className="">
                      <div className="graph_sectionw dot_section d-flex gap-2 justify-content-end align-items-center">
                        <p>Note: 1 ton = {weightUnit === 'kg' ? ' 907.18474 kg' : '2,000 lbs'}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default weightLiftedComponent;
